import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';

import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

import { AuthService } from "./_services/authentication.service";

import { appRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CharacterSheetComponent } from './character-sheet/character-sheet.component';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertComponent } from './alert';

import { environment } from '../environments/environment';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CharacterSheetsComponent } from './character-sheets/character-sheets.component';
import { CharacterSheetsCreateComponent } from './character-sheets/create/create.component';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { CharacterSheetCompetencesComponent } from './character-sheet/competences/competences.component';
import { CharacterSheetPrintComponent } from './character-sheet/print/print.component';
import { CharacterSheetSortsComponent } from './character-sheet/sorts/sorts.component';
import { CharacterSheetBackgroundComponent } from './character-sheet/background/background.component';
import { DashboardUpdateComponent } from './dashboard/update/dashboard.update.component';
import { AdminComponent } from './admin/admin.component';
import { AdminSetCrimsonComponent } from './admin/setCrimson/setCrimson.component';
import { AdminListLogComponent } from './admin/listLog/listLog.component';
import { AdminListReportComponent } from './admin/listReport/listReport.component';
import { AdminDatadumpPersonnageComponent } from './admin/datadumpPersonnage/datadumpPersonnage.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog/confirmation-dialog.service';
import { AdminDesinscriptionComponent } from './admin/desinscription/desinscription.component';
import { ToastrModule } from "ngx-toastr";
import { ErrorInterceptor } from './_helpers';
import { AdminSortsComponent } from './admin/sorts/sorts.component';
import { AdminCompetencesComponent } from './admin/competences/competences.component';
import { AdminFichePersonnageComponent } from './admin/fichePersonnage/fichePersonnage.component';
import { AdminListeFichePersonnageComponent } from './admin/listeFichePersonnage/listeFichePersonnage.component';


@NgModule({
  declarations: [
    ConfirmationDialogComponent,
    AdminComponent,
    AdminDatadumpPersonnageComponent,
    AdminSetCrimsonComponent,
    AdminDesinscriptionComponent,
    AdminListReportComponent,
    AdminListLogComponent,
    AdminSortsComponent,
    AdminCompetencesComponent,
    AdminFichePersonnageComponent,
    AdminListeFichePersonnageComponent,
    AppComponent,
    CharacterSheetComponent,
    AlertComponent,
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    DashboardComponent,
    DashboardUpdateComponent,
    CharacterSheetsComponent,
    CharacterSheetsCreateComponent,
    CharacterSheetCompetencesComponent,
    CharacterSheetSortsComponent,
    CharacterSheetBackgroundComponent,
    CharacterSheetPrintComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    appRoutingModule,
    NgbModule,
    NgSelectModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: "toast-bottom-right",
      progressBar: true,
      enableHtml: true
      /*toastClass: "alert",
      iconClasses: {
        error: 'alert-danger',
        info: 'alert-info',
        success: 'alert-success',
        warning: 'alert-warning'
      }*/
    }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthService,
    ConfirmationDialogService
  ],    
  bootstrap: [AppComponent]
})
export class AppModule { }
